var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height align-start",attrs:{"pa-0":"","fluid":""}},[_c('NotificationsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }